export enum MenuType {
  Main = 'main',
  Secondary = 'secondary',
}

export enum Role {
  Public = 'public',
  Employee = 'employee',
  Manager = 'manager',
}

export enum Breaks {
  Sickness = 'sickness',
  Vacation = 'vacation',
  Unpaid = 'unpaid',
}
